document.addEventListener('DOMContentLoaded', function () {
  var isTouch = window.matchMedia('(hover: none)').matches;
  if (!isTouch) return; // desktop relies on pure CSS :hover

  var cards = document.querySelectorAll('[data-flip-card]');

  cards.forEach(function (card) {
    var front = card.querySelector('.flip-card__face--front');
    var closeBtn = card.querySelector('[data-flip-close]');
    var quickview = card.querySelector('.flip-card__quickview');

    front.addEventListener('click', function (e) {
      // ignore taps on the quick view link itself so it still navigates
      if (quickview && quickview.contains(e.target)) return;
      e.preventDefault();

      // close any other open card first
      cards.forEach(function (other) {
        if (other !== card) other.classList.remove('is-flipped');
      });

      card.classList.toggle('is-flipped');
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        card.classList.remove('is-flipped');
      });
    }
  });

  // tapping outside any card closes all
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-flip-card]')) {
      cards.forEach(function (card) {
        card.classList.remove('is-flipped');
      });
    }
  });
});